import { LogoHp } from '@veneer/core';
import React, { useMemo } from 'react';
import * as S from './styles';

import { useDependencyManagerContext } from 'src/contexts/dependencyManager';
import { setCookie } from '../../utils/cookies';
import createIdHelper from '../../utils/createIdHelper';

type ErrorComponentType = {
  title: string;
  errorType?: string;
  onLoginClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

const ErrorComponent = ({
  title,
  onLoginClick,
  logoColor,
  ...props
}: ErrorComponentType) => {
  const { translate, northboundAPIs } = useDependencyManagerContext();
  const { theme } = northboundAPIs.v1;
  const themeMode = theme.getUserThemeMode();
  const { statusCode, errorDescription, errorMessage } = props;
  const { errorTitle, messages } = useMemo(() => {
    const cookieName = createIdHelper('setMaxAge0OnLogin', '');
    setCookie(escape(cookieName), 'true');
    return {
      errorTitle: statusCode,
      messages: [errorDescription, errorMessage]
    };
  }, [translate]);

  return (
    <S.Container
      data-testid={createIdHelper('error_component')}
      themeMode={themeMode}
      {...props}
    >
      <S.Header>
        <LogoHp
          appearance="singlecolor"
          size={48}
          background={logoColor || 'auto'}
        />
        <S.HeaderTitle themeMode={themeMode}>{title}</S.HeaderTitle>
      </S.Header>
      <S.Content data-testid={createIdHelper('access_denied')}>
        <S.FlexColumDiv>
          <S.ErrorTitle themeMode={themeMode}>{errorTitle}</S.ErrorTitle>
          {messages?.map?.((message, index) => (
            <S.Text
              key={index}
              themeMode={themeMode}
            >
              {message}
            </S.Text>
          ))}
        </S.FlexColumDiv>
        <S.LoginLinkButton
          data-testid={createIdHelper('access_denied_login')}
          onClick={onLoginClick}
        >
          Login
        </S.LoginLinkButton>
      </S.Content>
    </S.Container>
  );
};

export default ErrorComponent;
